<div class="profile-layout reverse loadable" [class.loading]="isLoading">
    <div class="profile-layout-content">
        <!-- Additional Questions-->
        <ui-card>
            <app-segment-header title="{{ 'applicant-tracker.components.questions.additionalQuestionsResponses' }}">
            </app-segment-header>

            <ng-container *ngIf="additionalApplicantQuestions?.length; else noAdditionalQuestions">
                <ui-banner *ngIf="applicant.applicantId" variant="info" class="margin-bottom-3">
                    <p>
                        {{
                            'applicant-tracker.components.questions.theseResponsesWereProvidedByTheApplicantOnTheirOriginalApplicati'
                                | translate
                        }}
                    </p>
                </ui-banner>

                <mat-accordion>
                    <mat-expansion-panel
                        class="additional-question-panel"
                        *ngFor="let answer of additionalApplicantQuestions"
                    >
                        <mat-expansion-panel-header class="header">
                            <mat-panel-title>
                                <div class="question-wrapper">
                                    <div class="visibility-wrapper">
                                        <mat-icon svgIcon="eye" class="visibility-icon"></mat-icon>
                                        <div class="visibility">
                                            {{
                                                answer.questionV2?.accessLevelLabel
                                                    | appTranslateOptions: HiringAccessLevelLabelOptions
                                            }}
                                        </div>
                                    </div>
                                    <div class="question">{{ answer.questionV2?.question }}</div>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <!-- Content -->
                        <div class="margin-top-2 additional-question-body">
                            <ng-container *ngIf="isFieldUrl(answer.answer); else plainText">
                                <a [href]="sanitizeUrl(answer.answer)" target="_blank">{{ answer.answer }}</a>
                            </ng-container>
                            <ng-template #plainText> {{ answer.answer }} </ng-template>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </ng-container>

            <ng-template #noAdditionalQuestions>
                <app-empty-state
                    src="/assets/illustrations/documents.png"
                    label="{{
                        'applicant-tracker.components.questions.theAdditionalQuestionsSectionIsEmptyForThisApplicant'
                    }}"
                ></app-empty-state>
            </ng-template>
        </ui-card>

        <!-- Auto Archive Questions-->
        <ui-card>
            <app-segment-header title="{{ 'applicant-tracker.components.questions.autoArchiveQuestions' }}">
                <ui-info
                    class="questions-info"
                    text="{{ 'applicant-tracker.components.questions.goToTheJobPostingSettingsToEditTheseQuestions' }}"
                ></ui-info>
            </app-segment-header>

            <ng-container *ngIf="this.applicant?.answers?.length; else noAutoArchiveQuestions">
                <ui-banner *ngIf="showAutoArchivedBanner" variant="warning" class="margin-bottom-4">
                    <p>
                        {{
                            'applicant-tracker.components.questions.thisApplicantWasAutoarchivedOnApplicantcreatedAtDatemediumDateBe'
                                | translate: { date: applicant.createdAt | appDate: 'mediumDate' }
                        }}
                    </p>
                </ui-banner>

                <div class="auto-archiving-questions-wrapper">
                    <div *ngFor="let answer of autoArchivingQuestions" class="answer-wrapper">
                        <div *ngIf="answer.questionV2?.question">
                            <div class="visibility-wrapper">
                                <mat-icon svgIcon="eye" class="visibility-icon"></mat-icon>
                                <div class="visibility">
                                    {{
                                        answer.questionV2?.accessLevelLabel
                                            | appTranslateOptions: HiringAccessLevelLabelOptions
                                    }}
                                </div>
                            </div>
                            <p class="question margin-bottom-1">{{ answer.questionV2?.question }}</p>
                            <p class="answer">{{ answer.answer }}</p>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #noAutoArchiveQuestions>
                <app-empty-state
                    src="/assets/illustrations/documents.png"
                    label="{{
                        'applicant-tracker.components.questions.theAutoArchivingQuestionsSectionIsEmptyForThisApplicant'
                    }}"
                ></app-empty-state>
            </ng-template>
        </ui-card>
    </div>
    <div class="profile-layout-sidebar">
        <app-comments-mini></app-comments-mini>
    </div>
</div>
